import React, { forwardRef } from "react";

const baseClassName =
  "flipmail-text-input w-full rounded-md bg-transparent px-3 py-2 text-theme-text placeholder:text-theme-dim border border-theme-border focus:outline-none focus:ring-1 focus:ring-theme-accent/60 focus:border-theme-accent font-mono text-sm";

const Input = forwardRef(function Input(
  { label, id, multiline = false, rows = 4, className = "", ...props },
  ref
) {
  return (
    <label className="block">
      {label ? (
        <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.1em] text-theme-muted">
          {label}
        </span>
      ) : null}
      {multiline ? (
        <textarea
          id={id}
          ref={ref}
          rows={rows}
          className={`${baseClassName} resize-y ${className}`}
          {...props}
        />
      ) : (
        <input id={id} ref={ref} className={`${baseClassName} ${className}`} {...props} />
      )}
    </label>
  );
});

export default Input;
